
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CommonPopup extends Vue {
  @Prop() public opened!: boolean;
  @Prop() public pullToRefresh!: boolean;

  parentPositionY = 0;

  closePop() {
    this.$emit("update:opened", false);
  }

  @Watch("opened")
  onOpenedCommon(): void {
    const wrap = document.getElementById("wrap");
    if (!wrap) {
      return;
    }
    if (this.opened) {
      // 팝업 전 y 포지션 기억
      if (this.$parent instanceof CommonPopup == false) {
        this.parentPositionY = window.scrollY;
      }
      // 부모창이 길면 팝업 밑으로 부모창 보임. 그래서 부모창 줄임
      wrap.classList.add("background");
      window.scrollTo(0, 0);
    } else if (this.$parent instanceof CommonPopup == false) {
      wrap.classList.remove("background");
      window.scrollTo(0, this.parentPositionY);
    }
  }

  isPullToRefreshEnabled = (type: boolean) => {
    if(this.$isMobile) {
      if(window["webViewBridge"]) {
        const {send} = window["webViewBridge"];
        send("refresh", {type});
      }
    }
  }
}
